var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrownGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.525 158.631H51.4196C48.4633 158.631 46.0117 156.18 46.0117 153.223C46.0117 150.267 48.4633 147.815 51.4196 147.815H123.525C126.481 147.815 128.933 150.267 128.933 153.223C128.933 156.18 126.481 158.631 123.525 158.631Z",
    fill: "#C0D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.666 39.8022L118.823 60.4243C115.002 63.1643 109.522 61.5059 107.863 57.1074L94.2356 20.7664C91.9282 14.4932 83.0593 14.4932 80.7519 20.7664L67.0519 57.0353C65.3935 61.5059 59.9856 63.1643 56.164 60.3522L27.3219 39.7301C21.5535 35.6922 13.9103 41.3885 16.2898 48.0943L46.2856 132.097C47.2951 134.981 50.0351 136.856 53.0635 136.856H121.78C124.808 136.856 127.548 134.909 128.558 132.097L158.553 48.0943C161.005 41.3885 153.362 35.6922 147.666 39.8022ZM105.484 106.355H69.4314C66.4751 106.355 64.0235 103.904 64.0235 100.947C64.0235 97.9911 66.4751 95.5396 69.4314 95.5396H105.484C108.44 95.5396 110.892 97.9911 110.892 100.947C110.892 103.904 108.44 106.355 105.484 106.355Z",
    fill: "#C0D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownGray);
export default __webpack_public_path__ + "static/media/crown-gray.056e248bafbcaae481bcfcea2271f492.svg";
export { ForwardRef as ReactComponent };